// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3rNL8","header":"ReportDetails_header__2c25H","title":"ReportDetails_title__2axW_","left":"ReportDetails_left__2FhXJ"};